// extracted by mini-css-extract-plugin
export var clickableWrapper = "_28-2";
export var placeholderIcon = "_28-3";
export var thumbnailCanvas = "_28-1";
export var thumbnailWrapper = "_28-0";